'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props as RegisterComponentProps } from './register.component';
import dynamic from 'next/dynamic';

const DynamicRegisterComponent: ComponentType<RegisterComponentProps> = dynamic(
  () => import('./register.component')
);

export default DynamicRegisterComponent;

export function calculateRegisterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 750 },
    { sinceWidth: 768, height: 750 },
    { sinceWidth: 1024, height: 800 }
  ];

  return {
    heightSinceWidth
  };
}
